import { FormBase } from 'core/components';

export default class LinkAddEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		return {
			fields: [
				{
					name: 'description',
					label: 'LINKSVIEW.DESCRIPTION',
					rules: 'required',
				},
				{
					name: 'url',
					label: 'LINKSVIEW.URL',
					rules: 'required',
				},
			],
		};
	}
}
